<template>
    <div> 
        <a @click="set_is_read()" class="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-toggle="dropdown">
            <i class="fas fa-bell"></i>
            <span ref="counter" class="count">{{ notification_count }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list">
            <a :href="this.employee_dashboard_url" class="dropdown-item">
                <p class="mb-0 font-weight-normal float-left">Je hebt {{ notification_count }} nieuwe meldingen</p>
                <span class="badge badge-pill badge-warning float-right">Bekijk alle</span>
            </a>
            <div class="dropdown-divider"></div>
            <a v-for="value in this.unread_notifications" :href="value['url']" class="dropdown-item preview-item">
                <div class="preview-thumbnail">
                    <div :class="value['bg_class']" class="preview-icon">
                        <i :class="value['icon']" class="mx-0"></i>
                    </div>
                </div>
                <div class="preview-item-content">
                    <p class="font-weight-light small-text" style="max-width: 250px; line-height: 18px;white-space: pre-line">
                        {{ value['description'] }}
                    </p>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                notification_count: 0,
            }
        },
        props: {
            unread_notifications: {},
            employee_dashboard_url: String
        },
        mounted() {
            if(Object.keys(this.unread_notifications).length === 0)
            {
                this.$refs['counter'].classList.add('d-none');
            }
            else
            {
                this.notification_count = Object.keys(this.unread_notifications).length;
            }
        },
        methods: {
            set_is_read: function () {
                let axios = require('axios');
                axios.put('/notifications/set-is-read/');

                this.$refs['counter'].classList.add('d-none');
            }
        }
    }
</script>
